<template>
    <v-dialog v-model="dialog" max-width="500px">
        <template v-slot:activator="{ on }">
            <v-btn v-on="on" text>
                <v-icon left>directions_car</v-icon>
                <span v-if="isNewCar">Opprett bil</span>
                <span v-else>Rediger bil</span>
            </v-btn>
        </template>
        <v-card>
            <v-toolbar>
                <v-toolbar-title v-if="loading">Laster...</v-toolbar-title>
                <v-toolbar-title v-else>
                    <span v-if="isNewCar">Opprett bil</span>
                    <span v-else>Rediger bil ({{ car.reg_number }})</span>
                </v-toolbar-title>
            </v-toolbar>

            <v-card-text v-if="loading">
                <v-progress-linear indeterminate/>
            </v-card-text>
            <div v-else>
                <v-container grid-list-md class="pa-3" v-if="dialog">
                    <customer-search v-model="car.customer_id"/>
                    <v-layout row wrap>
                        <v-flex md6>
                            <v-text-field label="Kontaktperson" v-model="car.contact_name"/>
                        </v-flex>
                        <v-flex md3>
                            <v-text-field label="Telefon (kontaktperson)" v-model="car.contact_phone"/>
                        </v-flex>
                        <v-flex md3>
                            <v-checkbox label="SMS" v-model="car.has_sms"/>
                        </v-flex>
                    </v-layout>
                    <v-layout row wrap>
                        <v-flex md6 lg2>
                            <v-text-field label="Reg.nr." v-model="car.reg_number"/>
                        </v-flex>
                        <v-flex md6 lg4>
                            <v-text-field label="Bilmerke / modell" v-model="car.type"/>
                        </v-flex>
                        <v-flex md12 lg6>
                            <car-category-select v-model="car.category_id" placeholder="Ukjent"/>
                        </v-flex>
                    </v-layout>
                    <v-layout row wrap>
                        <v-flex md3>
                            <v-text-field v-model="car.size_original" label="Originaldim."
                                          v-mask="'###/##-##'"
                                          return-masked-value hide-details clearable/>
                        </v-flex>
                        <v-flex md3>
                            <v-text-field v-model="car.size_original_2" label="Orig.dim. bak"
                                          v-mask="'###/##-##'"
                                          return-masked-value placeholder="Hvis ulik" hide-detail
                                          clearable/>
                        </v-flex>
                        <v-flex md3>
                            <v-text-field persistent-hint v-model="car.load_index" label="Lasteindeks"
                                          hint="Verdi: 0 - 199" v-mask="'###'"/>
                        </v-flex>
                        <v-flex md3>
                            <v-text-field persistent-hint v-model="car.speed_rating" label="Hastighetsindeks"
                                          hint="Verdi: B - Z" v-mask="'A'"/>
                        </v-flex>
                    </v-layout>
                    <div>
                        <v-textarea outlined label="Notat" v-model="car.note" hide-details ref="carNote"/>
                        <div class="text-right">
                            <v-btn text color="purple" @click="insertDateInNote">
                                <v-icon left>event</v-icon>
                                Sett inn dato
                            </v-btn>
                        </div>
                    </div>
                    <v-layout row wrap>
                        <v-flex md6>
                            <v-select class="mt-0" label="Fakturering" :items="invoiceIntervalItems"
                                      v-model="car.invoice_interval"/>
                        </v-flex>
                        <v-flex md3>
                        </v-flex>
                    </v-layout>
                    <v-checkbox class="mt-0" label="Leasingbil" v-model="car.is_leasing"/>
                </v-container>
                <v-card-actions>
                    <v-btn color="red" text @click="dialog = false">
                        <v-icon left>close</v-icon>
                        Lukk
                    </v-btn>
                    <v-spacer/>
                    <v-btn color="green" text @click="save" :loading="loading">
                        <v-icon left>save</v-icon>
                        Lagre
                    </v-btn>
                </v-card-actions>
            </div>
        </v-card>
    </v-dialog>
</template>

<script>
import moment from 'moment';
import CustomerSearch from './CustomerSearch';
import CarCategorySelect from './CarCategorySelect';
import {invoiceIntervalItems} from '../../helpers';

export default {
    components: {
        CustomerSearch,
        CarCategorySelect
    },

    props: {
        carId: [Number, null],
        customerId: [Number, null]
    },

    data() {
        return {
            loading: false,
            dialog: false,
            car: {
                customer_id: this.customerId || null,
                is_leasing: false, // Bool must have default.
                invoice_interval: 12
            }
        }
    },

    methods: {
        loadData() {
            if (this.carId) {
                this.loading = true;
                this.$http.get(`cars/${this.carId}`).then(response => {
                    this.car = response.data.data;
                }).finally(() => this.loading = false);
            }
        },
        save() {
            this.loading = true;
            let request;
            if (this.carId) {
                request = this.$http.put(`cars/${this.carId}`, this.car);
            } else {
                request = this.$http.post('cars', this.car);
            }

            request.then(response => {
                this.car = response.data.data;
                this.$emit('save', this.car);
                this.dialog = false;
                this.$root.addMessage('Bilen ble lagret.', 'success');
            }).finally(() => {
                this.loading = false;
            });
        },
        insertDateInNote() {
            // Avoid insertin 'null' as string if note is null.
            if (!this.car.note) this.car.note = '';

            // Insert date.
            let date = moment().format('ll');
            this.car.note += `\n${date}: `;
            this.car.note = this.car.note.trimStart();
            this.$refs['carNote'].focus();
        }
    },

    watch: {
        dialog() {
            if (this.dialog) {
                this.loadData();
            }
        },

        customerId() {
            this.car.customer_id = this.customerId || null;
        }
    },

    computed: {
        isNewCar() {
            return !this.carId;
        },
        invoiceIntervalItems() {
            return invoiceIntervalItems
        }
    }
}
</script>
